import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import { ReactComponent as Search } from 'assets/images/search_icon.svg';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  flex: 1;
`;

export const Content = styled.div`
  @media ${({ theme }) => theme.device.mobile} {
    background: ${ColorPalette.HEX.Lotion};
    min-height: 100%;
  }

  @media ${({ theme }) => theme.device.desktop} {
    width: 966px;
    margin: 0 auto;
  }
`;

export const TabContainer = styled.div`
  display: flex;
  @media ${({ theme }) => theme.device.desktop} {
    padding: 8px;
    background: ${({ theme }) => theme.tabs.background};
    border-radius: 64px;
  }
`;

export const Subtitle = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.usersList.dataColor};
  text-align: center;
  font-weight: normal;
`;

export const HeaderContainer = styled.div`
  text-align: center;
  width: 200px;
`;

export const IconSearch = styled(Search)`
  width: 16px;
  height: 16px;
  margin: 0 auto;
  @media ${({ theme }) => theme.device.desktop} {
    width: 32px;
    height: 32px;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  @media ${({ theme }) => theme.device.mobile} {
    margin: 16px 16px 0;
  }
`;

export const SearchButton = styled.div`
  cursor: pointer;
  width: 48px;
  height: 48px;
  border-radius: 24px;
  color: ${ColorPalette.HEX.OuterSpace};
  background: ${ColorPalette.HEX.White};
  box-shadow: 0 2px 12px 0 rgba(${ColorPalette.RGB.DeepTaupe2}, 0.16);
  display: flex;
  align-content: center;
  justify-content: center;
  flex-direction: column;
  @media ${({ theme }) => theme.device.desktop} {
    width: 56px;
    height: 56px;
    border-radius: 26px;
    margin-left: 16px;
    margin-top: 5px;
    box-shadow: 0 2px 12px 0 rgba(128, 98, 96, 0.16);
  }
  @media ${({ theme }) => theme.device.mobile} {
    border: 1px solid #efece9;
    width: 34px;
    height: 34px;
  }
`;
